/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import NextIcon from "dc-icons/viewer2021/SDC_SkipRight18_N.svg";
import { isNextButtonDisabled } from "selectors/readAloudSelectors";
import ReadAloudCss from "components/readAloud/readAloud.css";

const mapStoreToProps = stores => ({
  icon: NextIcon,
  className: ReadAloudCss.controls,
  shouldDisable: isNextButtonDisabled(stores),
  clickHandler: () => stores.readAloudStore.next(),
  ariaLabel: "arialabel.readAloudNext",
  tooltipString: "tooltip.readAloudNext"
});

const ReadAloudNextContainer = inject(mapStoreToProps)(ButtonWrapper);
export { ReadAloudNextContainer };
